import request from '../utils/request'

const prefix = '/api/v1/back'


/**
 * 选题部分
 *
 */


/**
 * 新媒体账号（查询列表）
 * @param {*} query
 */
export const mediaaccountlist = (query) => {
    return request({
        url: `${prefix}/media/account/list`,
        method: 'get',
        params: query
    })
}

/**
 * 新媒体账号（创建）
 * @param {*} query
 */
export const mediaaccountCreate = (query) => {
    return request({
        url: `${prefix}/media/account`,
        method: 'post',
        data: query
    })
}

/**
 * 新媒体账号（修改）
 * @param {*} query
 */
export const mediaaccountUpdate = (query) => {
    return request({
        url: `${prefix}/media/account`,
        method: 'put',
        data: query
    })
}

/**
 * 新媒体账号（删除）
 * @param {*} query
 */
export const mediaaccountDestroy = (query) => {
    return request({
        url: `${prefix}/media/account`,
        method: 'delete',
        data: query
    })
}



/**
 * 新媒体账号（批量删除）
 * @param {*} query
 */
export const mediaaccountlistDestroy = (query) => {
    return request({
        url: `${prefix}/media/account/list`,
        method: 'delete',
        data: query
    })
}


/**
 * 选题（创建）
 * @param {*} query
 */
export const mediatopicCreate = (query) => {
    return request({
        url: `${prefix}/media/topic`,
        method: 'post',
        data: query
    })
}

/**
 * 选题（查询列表）
 * @param {*} query
 */
export const mediatopiclist = (query) => {
    return request({
        url: `${prefix}/media/topic/list`,
        method: 'get',
        params: query
    })
}

/**
 * 选题（删除
 * @param {*} query
 */
export const mediatopicDestroy = (query) => {
    return request({
        url: `${prefix}/media/topic`,
        method: 'delete',
        data: query
    })
}

/**
 * 选题（批量删除）
 * @param {*} query
 */
export const mediatopiclistDestroy = (query) => {
    return request({
        url: `${prefix}/media/topic/list`,
        method: 'delete',
        data: query
    })
}

/**
 * 选题（修改）
 * @param {*} query
 */
export const mediatopicUpdate = (query) => {
    return request({
        url: `${prefix}/media/topic`,
        method: 'put',
        data: query
    })
}


/**
 * 选题（查询详情）
 * @param {*} query
 */
export const mediatopicOne = (query) => {
    return request({
        url: `${prefix}/media/topic`,
        method: 'get',
        params: query
    })
}


/**
 * 文案（查询列表）
 * @param {*} query
 */
export const mediawritinglist = (query) => {
    return request({
        url: `${prefix}/media/writing/list`,
        method: 'get',
        params: query
    })
}


/**
 * 文案（创建）
 * @param {*} query
 */
export const mediawritingCreate = (query) => {
    return request({
        url: `${prefix}/media/writing`,
        method: 'post',
        data: query
    })
}


/**
 * 文案（查询详情）
 * @param {*} query
 */
export const mediawritingOne = (query) => {
    return request({
        url: `${prefix}/media/writing`,
        method: 'get',
        params: query
    })
}


/**
 * 文案（修改）
 * @param {*} query
 */
export const mediawritingUpdate = (query) => {
    return request({
        url: `${prefix}/media/writing`,
        method: 'put',
        data: query
    })
}



/**
 * 文案（删除）
 * @param {*} query
 */
export const mediawritingDestroy = (query) => {
    return request({
        url: `${prefix}/media/writing`,
        method: 'delete',
        data: query
    })
}

/**
 * 文案（删除列表） 
 * @param {*} query
 */
export const mediawritinglistDestroy = (query) => {
    return request({
        url: `${prefix}/media/writing/list`,
        method: 'delete',
        data: query
    })
}


/**
 * 发布（创建）
 * @param {*} query
 */
export const mediapublishCreate = (query) => {
    return request({
        url: `${prefix}/media/publish`,
        method: 'post',
        data: query
    })
}


/**
 * 发布（查询列表） 
 * @param {*} query
 */
export const mediapublishlist = (query) => {
    return request({
        url: `${prefix}/media/publish/list`,
        method: 'get',
        params: query
    })
}


/**
 * 发布（查询详情）
 * @param {*} query
 */
export const mediapublishOne = (query) => {
    return request({
        url: `${prefix}/media/publish`,
        method: 'get',
        params: query
    })
}


/**
 * 发布（修改） 
 * @param {*} query
 */
export const mediapublishUpdate = (query) => {
    return request({
        url: `${prefix}/media/publish`,
        method: 'put',
        data: query
    })
}

/**
 * 发布（删除） 
 * @param {*} query
 */
export const mediapublishDestroy = (query) => {
    return request({
        url: `${prefix}/media/publish`,
        method: 'delete',
        data: query
    })
}

/**
 * 发布（删除列表）
 * @param {*} query
 */
export const mediapublishlistDestroy = (query) => {
    return request({
        url: `${prefix}/media/publish/list`,
        method: 'delete',
        data: query
    })
}

/**
 * 发布（状态修改） 
 * @param {*} query
 */
export const mediapublishstatusUpdate = (query) => {
    return request({
        url: `${prefix}/media/publish/status`,
        method: 'put',
        data: query
    })
}

/**
 * 文案（导出）
 * @param {*} query
 */
export const mediawritinglistexport = (query) => {
    return request({
        url: `${prefix}/media/writing/list/export`,
        method: 'get',
        params: query
    })
}

